<div class="modal-body" [attr.data-role]="'modal-body'" [id]="bodyId" [attr.tabIndex]="scrollable ? '0' : null">
  @if (customModalBody) {
    <ng-container *ngTemplateOutlet="$safeNavigationMigration(customModalBody?.templateRef); context: hostRef">
    </ng-container>
  } @else {
    <!-- eslint-disable-next-line @angular-eslint/template/i18n -->
    Custom Body
  }
</div>
